<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-header :title="title" :breadcrumbs="breadcrumbs" :back="true"></app-sub-header>
      <!--end::Container-->
    </div>

    <div class="container-xxl" v-if="isLoading">
      <Loader />
    </div>

    <div v-else class="post d-flex flex-column flex-lg-row flex-column-fluid" id="kt_post">


      <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 mb-5">
                <div>
                  <ImageInput
                      v-model:image="formData.image"
                      :current-image="formData.image_url" :default-image="defaultPromotionImage" image-class="w-150px h-150px mb-1"/>
                </div>
              </div>
              <div class="col-md-6 mb-5">
                <div class="row">
                  <Input
                      containerClass="col-12 mb-5 mt-auto"
                      type="text"
                      :placeholder="$t('promotion.title')"
                      name="promotion-title"
                      input-class="form-control-solid"
                      size="lg"
                      :isRequired="true"
                      v-model="formData.title"
                      :label="$t('promotion.title')"
                  />
                  <Select2
                      containerClass="col-md-12 mb-5"
                      name="promotionApplyTo"
                      :label="$t('promotion.applyTo')"
                      labelClass="form-label fs-6 fw-bolder text-black"
                      :multiple="false"
                      :selectClass="'form-select form-control-lg form-control-solid form-select-solid'"
                      :isRequired="true"
                      :placeholderText="$t('promotion.apply_placeholder')"
                      v-model="formData.apply">
                    <option v-for="(apply, index) in getApplies" :key="index"
                            :value="apply.value"> {{ apply[locale] }}
                    </option>
                  </Select2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label for="promotionDescription" class="form-label fs-6 text-black">{{
                    $t('promotion.description')
                  }}</label>
                <textarea class="form-control form-control-lg form-control-solid" v-model="formData.description"
                          id="promotionDescription" :placeholder="$t('promotion.description_placeholder')"
                          rows="3"></textarea>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column align-items-stretch">
                  <div class="row">
                    <InputDate
                        containerClass="col-md-6 mb-5"
                        name="promotionStartDate"
                        type="text"
                        :label="$t('promotion.startDate')"
                        labelClass="form-label fs-6 text-black"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        :isRequired="false"
                        size="lg"
                        :placeholder="$t('promotion.startDate')"
                        v-model="formData.startDate"
                        :containerClass="'col-12 col-sm-6 mb-5'"
                    />
                    <InputDate
                        containerClass="col-md-6 mb-5"
                        name="promotionEndDate"
                        type="text"
                        :label="$t('promotion.endDate')"
                        labelClass="form-label fs-6 text-black"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        :isRequired="true"
                        size="lg"
                        :placeholder="$t('promotion.endDate')"
                        v-model="formData.endDate"
                        :containerClass="'col-12 col-sm-6 mb-5'"
                    />
                  </div>
                  <div>
                    <div class="form-check form-check-custom form-check-solid mt-auto">
                      <input class="form-check-input me-5" type="checkbox" v-model="formData.online"
                             id="form_checkbox"/>
                      <label class="form-label fs-6 text-black" for="form_checkbox">
                        {{ $t('promotion.activePromotion') }}
                      </label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mt-3" v-if="!fromStagnantSelection">
                      <input class="form-check-input me-5" type="checkbox" v-model="formData.appliesToAllProducts"
                             @change="onAppliesToAllProductsChange"
                             id="applies_to_all_checkbox"/>
                      <label class="form-label fs-6 text-black" for="applies_to_all_checkbox">
                        {{ $t('promotion.appliesToAllProducts') }}
                      </label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mt-3" v-if="hasMultipleShops">
                      <input class="form-check-input me-5" type="checkbox" v-model="formData.appliesToAllShops"
                             id="applies_to_all_shops_checkbox"/>
                      <label class="form-label fs-6 text-black" for="applies_to_all_shops_checkbox">
                        {{ $t('promotion.appliesToAllShops') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="hasMultipleShops && !formData.appliesToAllShops">
              <div class="separator my-10"></div>
              <div class="col-md-6 mb-5">
                <Select2
                    containerClass=""
                    name="promotionShops"
                    :label="$t('promotion.applicableShops')"
                    labelClass="form-label fs-6 fw-bolder text-black"
                    :multiple="true"
                    :selectClass="'form-select form-control-lg form-control-solid form-select-solid'"
                    :isRequired="true"
                    :placeholderText="$t('promotion.applicableShopsPlaceholder')"
                    v-model="formData.shops">
                  <option v-for="shop in societyShops" :key="shop.id" :value="shop.id">{{ shop.name }}</option>
                </Select2>
              </div>
            </div>

            <div v-if="formData.appliesToAllProducts" class="row">
              <div class="separator my-10"></div>
              <p class="text-muted fs-7 col-12">{{ $t('promotion.appliesToAllProductsHint') }}</p>
              <div class="col-md-6 mb-5">
                <Select2
                    containerClass=""
                    name="defaultDiscountType"
                    :label="$t('promotion.discountType')"
                    labelClass="form-label fs-6 fw-bolder text-black"
                    :multiple="false"
                    :selectClass="'form-select form-control-lg form-control-solid form-select-solid'"
                    :isRequired="true"
                    :placeholderText="$t('promotion.discountTypePlaceholder')"
                    v-model="formData.defaultTypeDiscount">
                  <option v-for="(discount, index) in priceDiscountTypes" :key="index"
                          :value="discount.value">{{ discount[locale] }}
                  </option>
                </Select2>
              </div>
              <div class="col-md-6 mb-5" v-if="formData.defaultTypeDiscount?.toString().toLowerCase() === 'amount'">
                <label class="form-label fs-6 fw-bolder text-black">
                  <span class="required">{{ $t('promotion.discountAmount') }} {{ currency ? ('(' + currency + ')') : '' }}</span>
                </label>
                <VueNumberFormat class="form-control form-control-lg form-control-solid" required
                                 v-model:value="formData.defaultReduction"
                                 :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger:true }"
                ></VueNumberFormat>
              </div>
              <div class="col-md-6 mb-5" v-if="formData.defaultTypeDiscount?.toString().toLowerCase() === 'percent'">
                <label class="form-label fs-6 fw-bolder text-black">
                  <span class="required">{{ $t('promotion.discountAmount') }}</span>
                </label>
                <div class="input-group mb-5">
                  <input type="number" @keypress="onlyNumber" step=".01"
                         class="form-control form-control-solid"
                         v-model="formData.defaultReduction" required
                         :placeholder="$t('promotion.discountAmountPlaceholder')"/>
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>

            <template v-else>
            <div id="products_repeater" v-for="(promotion, index) in formData.promotions" class="row" :key="index">
              <div class="separator my-10"></div>
              <Input
                  containerClass="col-md-6 mb-5"
                  type="text"
                  :placeholder="$t('promotion.typePlaceholder')"
                  name="promotion-type"
                  input-class="form-control-solid"
                  size="lg"
                  :isRequired="true"
                  v-model="formData.promotions[index].tag"
                  :label="$t('promotion.type')"
              />
              <div class="col-md-6">

                <div class="row">
                  <Select2
                      containerClass="col-md-6 mb-5"
                      :name="'promotionDiscountType'+index"
                      :label="$t('promotion.discountType')"
                      labelClass="form-label fs-6 fw-bolder text-black"
                      :multiple="false"
                      :selectClass="'form-select form-control-lg form-control-solid form-select-solid'"
                      :isRequired="true"
                      :placeholderText="$t('promotion.discountTypePlaceholder')"
                      v-model="formData.promotions[index].type_discount">
                    <option v-for="(discount, index) in getDiscountTypes" :key="index"
                            :value="discount.value">{{ discount[locale] }}
                    </option>
                  </Select2>


                  <div class="col-md-6 mb-5"
                       v-if="formData.promotions[index].type_discount?.toString().toLowerCase() == 'amount'">
                    <label class="form-label fs-6 fw-bolder text-black">
                  <span class="required">
                    {{ $t('promotion.discountAmount') }} {{ currency ? ('(' + currency + ')') : '' }}</span>
                    </label>

                    <VueNumberFormat class="form-control form-control-lg form-control-solid" required
                                     v-model:value="formData.promotions[index].reduction"
                                     :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger:true }"
                    ></VueNumberFormat>
                  </div>
                  <div class="col-md-6 mb-5"
                       v-if="formData.promotions[index].type_discount?.toString().toLowerCase() == 'percent'">
                    <label class="form-label fs-6 fw-bolder text-black">
                      <span class="required">{{ $t('promotion.discountAmount') }}</span>
                    </label>
                    <div class="input-group mb-5">
                      <input type="number"
                             @keypress="onlyNumber"
                             step=".01"
                             class="form-control form-control-solid"
                             v-model="formData.promotions[index].reduction"
                             required
                             :placeholder="$t('promotion.discountAmountPlaceholder')"/>
                      <span class="input-group-text" id="basic-addon2">%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-5" v-if="formData.promotions[index].type_discount === 'buy_x_get_y'">
                <div class="col-md-3 mb-3">
                  <label class="form-label fs-6 fw-bolder text-black required">{{ $t('promotion.buy_quantity') }}</label>
                  <input type="number" min="1" step="1" class="form-control form-control-solid" required
                         v-model.number="formData.promotions[index].buy_quantity" />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="form-label fs-6 fw-bolder text-black required">{{ $t('promotion.get_quantity') }}</label>
                  <input type="number" min="1" step="1" class="form-control form-control-solid" required
                         v-model.number="formData.promotions[index].get_quantity" />
                </div>
                <Select2
                    containerClass="col-md-6 mb-3"
                    :name="'promotionGift' + index"
                    :label="$t('promotion.gift_product')"
                    labelClass="form-label fs-6 fw-bolder text-black"
                    :multiple="true"
                    :maxSelection="1"
                    :selectClass="'form-select form-control-lg form-control-solid form-select-solid min-h-45px'"
                    :placeholderText="$t('promotion.gift_same_product')"
                    v-model="formData.promotions[index].gift_ids">
                  <optgroup v-for="category in categoriesWithProducts" :key="category.category_id" :label="category.category_name">
                    <option v-for="product in category.sale_elements" :key="product.id" :value="product.id">{{ product.name }}</option>
                  </optgroup>
                </Select2>
                <div class="col-12 form-text">{{ $t('promotion.buy_x_get_y_hint', { buy: formData.promotions[index].buy_quantity || 'X', get: formData.promotions[index].get_quantity || 'Y' }) }}</div>
              </div>

              <div class="row mb-3">
                <div class="col d-flex flex-wrap gap-2">
                  <button
                      type="button"
                      class="btn btn-sm btn-light-primary"
                      @click="openProductModal(index)"
                  >
                    <i class="fa fa-boxes"></i> {{ $t('promotion.add_products') }}
                  </button>

                  <button
                      type="button"
                      class="btn btn-sm btn-light-primary"
                      @click="openCategoryModal(index)"
                  >
                    <i class="fa fa-layer-group"></i> {{ $t('promotion.add_by_category') }}
                  </button>
                </div>
                <div
                    v-if="formData.promotions[index].products.length"
                    class="col-md-12 mt-4"
                >
                  <div class="d-flex align-items-center mb-3 gap-2">
                    <label class="form-label fw-bold mb-0">
                      {{ $t('promotion.selected_products') }}
                    </label>
                    <span class="badge badge-light-primary">{{ formData.promotions[index].products.length }}</span>
                  </div>

                  <div class="product-scroll-list">
                    <div
                        v-for="(group, gIdx) in getGroupedProducts(index)"
                        :key="gIdx"
                        class="category-group"
                    >
                      <!-- En-tête catégorie -->
                      <div class="category-group-header">
                        <i class="fa fa-layer-group me-2 text-primary fs-7"></i>
                        <span>{{ group.categoryName }}</span>
                        <span class="badge badge-light-primary ms-2">{{ group.products.length }}</span>
                      </div>

                      <!-- Produits de la catégorie -->
                      <ul class="list-group list-group-flush">
                        <li
                            v-for="item in group.products"
                            :key="item.id"
                            class="list-group-item d-flex justify-content-between align-items-center py-2 ps-4"
                        >
                          <span class="text-gray-700">{{ item.name }}</span>
                          <button
                              type="button"
                              class="btn btn-sm btn-light-danger"
                              @click="removeProduct(index, item.id)"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>




<!--              <div class="col-md-1 col-sm-12  mt-6">-->
<!--                <button :data-key="index" @click.prevent="dropRow(index)" type="button"-->
<!--                        class="btn btn-sm btn-light-danger" data-kt-element="remove-item">-->
<!--                              <span class="svg-icon svg-icon-3">-->
<!--                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"-->
<!--                                     fill="none">-->
<!--                                  <path-->
<!--                                      d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"-->
<!--                                      fill="currentColor"/>-->
<!--                                  <path opacity="0.5"-->
<!--                                        d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"-->
<!--                                        fill="currentColor"/>-->
<!--                                  <path opacity="0.5"-->
<!--                                        d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"-->
<!--                                        fill="currentColor"/>-->
<!--                                </svg>-->
<!--                              </span>-->
<!--                  {{ $t('product.delete') }}-->
<!--                </button>-->
<!--              </div>-->
<!--              <div class="form-group mt-5">-->
<!--                <button @click.prevent="addRow" type="button" class="btn btn-sm btn-light-primary">-->
<!--                            <span class="svg-icon svg-icon-2">-->
<!--                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"-->
<!--                                   fill="none">-->
<!--                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1"-->
<!--                                      transform="rotate(-90 11 18)" fill="currentColor"/>-->
<!--                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>-->
<!--                              </svg>-->
<!--                            </span>-->
<!--                  {{ $t('promotion.add_tag') }}-->
<!--                </button>-->
<!--              </div>-->

            </div>
            </template>

            <div class="card-footer">
              <div class="row">
                <div class="d-flex justify-content-end mt-10">
                  <button @click="updatePromotion" class="btn btn-sm btn-primary fw-bolder"
                          :disabled="processUpdating" style="margin-right: 10px;">
                    <span class="indicator-label">{{ $t('button.save') }}</span>
                    <span class="indicator-progress" v-show="processUpdating">{{ $t('loading') }}
                          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                  </button>
                  <button @click="() => router.push({ name: 'promotions' })" class="btn btn-sm btn-light fw-bolder">
                    {{ $t("button.cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 px-5 px-lg-0">

        <!-- Notifications automatiques (heure locale) : annonce au lancement, rappel avant la fin -->
        <div class="card mb-5">
          <div class="card-header align-items-center border-0 mt-4 min-h-auto">
            <h3 class="card-title align-items-start flex-column">
              <span class="fw-bold mb-1 text-gray-900">{{ $t('promotion.auto_notify') }}</span>
            </h3>
            <div class="card-toolbar">
              <div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input" type="checkbox" v-model="formData.autoNotify" id="auto_notify_checkbox"/>
              </div>
            </div>
          </div>
          <div class="card-body pt-2">
            <div class="text-muted fs-7 mb-4">{{ $t('promotion.auto_notify_hint') }}</div>
            <template v-if="formData.autoNotify">
              <div class="mb-4">
                <label class="form-label fs-6 text-black">{{ $t('promotion.notify_start_time') }}</label>
                <input type="time" class="form-control form-control-solid" v-model="formData.notifyStartTime" />
              </div>
              <div class="row">
                <div class="col-12 col-sm-6 mb-4">
                  <label class="form-label fs-6 text-black">{{ $t('promotion.notify_reminder_days') }}</label>
                  <div class="input-group">
                    <input type="number" min="0" max="30" step="1" class="form-control form-control-solid" v-model.number="formData.notifyReminderDays" />
                    <span class="input-group-text">{{ $t('promotion.days_short') }}</span>
                  </div>
                </div>
                <div class="col-12 col-sm-6 mb-4">
                  <label class="form-label fs-6 text-black">{{ $t('promotion.notify_reminder_time') }}</label>
                  <input type="time" class="form-control form-control-solid" v-model="formData.notifyReminderTime" />
                </div>
              </div>
              <div class="notice bg-light-primary rounded border-primary border border-dashed p-3 fs-7 text-gray-700">
                {{ formData.endDate
                  ? $t('promotion.auto_notify_summary', { start: formData.notifyStartTime || '09:00', days: formData.notifyReminderDays ?? 1, time: formData.notifyReminderTime || '10:00' })
                  : $t('promotion.auto_notify_summary_no_end', { start: formData.notifyStartTime || '09:00' }) }}
              </div>
            </template>
          </div>
        </div>

        <div class="card card-xl-stretch" v-if="!isCreate">
          <div class="card-header align-items-center border-0 mt-4">
            <h3 class="card-title align-items-start flex-column">
              <span class="fw-bold mb-2 text-gray-900">Notifications envoyées</span>
            </h3>
            <button
                class="btn btn-sm btn-primary"
                @click="sendNotifyPromotion(promotion.id)"
            >
              <i class="fas fa-bell me-1"></i> Envoyer une notif
            </button>
            <div class="card-toolbar">
              <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                      data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                <i class="ki-duotone ki-category fs-6"><span class="path1"></span><span class="path2"></span><span
                    class="path3"></span><span class="path4"></span></i>
              </button>
            </div>
          </div>

          <div class="card-body pt-5">
            <div class="timeline-label">

              <div
                  v-for="(notification, index) in promotion.notifications"
                  :key="notification.id"
                  class="timeline-item"
              >
                <!-- Date -->
                <div class="timeline-label fw-bold text-gray-800 fs-6">
                  {{ formatTime(notification.sent_at) }}
                </div>

                <!-- Badge -->
                <div class="timeline-badge">
                  <i class="fa fa-genderless text-primary fs-1"></i>
                </div>

                <!-- Contenu -->
                <div class="timeline-content fw-semibold text-gray-800 ps-3">
            <span>
              Notification <strong class="text-primary">« {{ labelType(notification.type) }} »</strong>
            </span>
                  <div v-if="notification.message" class="text-gray-600 fs-7 mt-1">
                    <strong v-if="notification.title">{{ notification.title }} — </strong>{{ notification.message }}
                  </div>
                  <div class="text-muted fs-7">
                    {{ formatDate(notification.sent_at) }}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Envoi manuel d'une notification : texte prérempli selon le type, modifiable -->
    <div class="modal fade" id="notifyPromotionModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('promotion.notify_modal_title') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <Select2
                containerClass="mb-5"
                name="notifyType"
                parentId="#notifyPromotionModal"
                :label="$t('promotion.notify_type')"
                labelClass="form-label fs-6 fw-bolder text-black"
                :multiple="false"
                :showSearch="false"
                :selectClass="'form-select form-select-solid'"
                v-model="notifyForm.type">
              <option value="manual">{{ $t('promotion.notify_type_manual') }}</option>
              <option value="start">{{ $t('promotion.notify_type_start') }}</option>
              <option value="reminder">{{ $t('promotion.notify_type_reminder') }}</option>
            </Select2>
            <div class="mb-5">
              <label class="form-label fs-6 fw-bolder text-black">{{ $t('promotion.notify_title_label') }}</label>
              <input type="text" class="form-control form-control-solid" maxlength="80" v-model="notifyForm.title" />
            </div>
            <div class="mb-3">
              <label class="form-label fs-6 fw-bolder text-black required">{{ $t('promotion.notify_message_label') }}</label>
              <textarea class="form-control form-control-solid" rows="3" maxlength="240" v-model="notifyForm.message"></textarea>
              <div class="form-text text-end">{{ (notifyForm.message || '').length }}/240</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.cancel') }}</button>
            <button type="button" class="btn btn-sm btn-primary" :disabled="notifySending || !(notifyForm.message || '').trim()" @click="submitNotifyPromotion">
              <i class="fas fa-bell me-1"></i> {{ $t('promotion.notify_send') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="promotionByCategoryModal" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <!-- HEADER -->
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('promotion.add_by_category') }}
            </h5>
            <button class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <!-- BODY -->
          <div class="modal-body">

            <!-- Categories -->
            <label class="form-label fw-bold">{{ $t('product.category') }}</label>
            <select
                :id="'category_select_0'"
                class="form-select kt_select2 h-50px"
                data-control="select2"
                data-dropdown-parent="#promotionByCategoryModal"
                multiple
                v-model="categoryModal.selectedCategories"
            >
              <template v-for="category in getCategories" :key="category.id">
                <!-- Parent non sélectionnable -->
                <option disabled class="parent-option">{{ category.name }}</option>

                <!-- Sous-catégories sélectionnables -->
                <option
                    v-for="sub in category.childrens"
                    :key="sub.id"
                    :value="sub.id"
                >
                  &nbsp;&nbsp;— {{ sub.name }}
                </option>
              </template>
            </select>

            <!-- Preview -->
            <div v-if="categoryModal.products.length" class="mt-4">
              <div class="d-flex align-items-center mb-3 gap-2">
                <label class="form-label fw-bold mb-0">{{ $t('promotion.selected_products') }}</label>
                <span class="badge badge-light-primary">{{ categoryModal.products.length }}</span>
              </div>
              <div class="product-scroll-list">
                <div
                    v-for="(categoryGroup, idx) in groupedProductsByCategory"
                    :key="idx"
                    class="category-group"
                >
                  <div class="category-group-header">
                    <i class="fa fa-layer-group me-2 text-primary fs-7"></i>
                    <span>{{ categoryGroup.categoryName }}</span>
                    <span class="badge badge-light-primary ms-2">{{ categoryGroup.products.length }}</span>
                  </div>
                  <ul class="list-group list-group-flush">
                    <li v-for="p in categoryGroup.products" :key="p.id"
                        class="list-group-item d-flex justify-content-between align-items-center py-2 ps-4">
                      <span class="text-gray-700">{{ p.name }}</span>
                      <button type="button" class="btn btn-sm btn-light-danger" @click="removeProductFromModal(p.id)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>


          </div>

          <!-- FOOTER -->
          <div class="modal-footer">
            <button class="btn btn-light btn-light-close" data-bs-dismiss="modal">
              {{ $t('button.cancel') }}
            </button>
            <button class="btn btn-primary" @click="confirmCategoryProducts">
              {{ $t('button.add') }}
            </button>
          </div>

        </div>
      </div>
    </div>
    <div class="modal fade" id="productModal" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">{{ $t('promotion.add_products') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body">
            <Select2
                containerClass="col-md-10 mb-5 h-auto"
                :name="'promotionsProducts'+currentPromotionIndex"
                :label="$t('promotion.products')"
                labelClass="form-label fs-6 fw-bolder text-black"
                :multiple="true"
                :selectClass="'form-select form-control-lg form-control-solid form-select-solid min-h-45px'"
                :isRequired="true"
                :placeholderText="$t('promotion.products')"
                v-model="modalSelectedProducts"
            >
              <optgroup v-for="category in categoriesWithProducts"
                        :key="category.category_id"
                        :label="category.category_name"
              >
                <option v-for="product in category.sale_elements" :key="product.id"
                        :value="product.id"> {{ product.name }}
                </option>
              </optgroup>
            </Select2>
          </div>

          <div class="modal-footer">
            <button class="btn btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.cancel') }}</button>
            <button class="btn btn-primary" @click="confirmProducts">{{ $t('button.add') }}</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { brandedPlaceholder } from '@/composables/useBranding'

import AppSubHeader from "@/views/Promotion/Partials/AppSubHeader.vue";
import Loader from "@/components/Loader.vue";
import {computed, nextTick, onBeforeUnmount, onMounted, onUpdated, reactive, ref, watch} from "vue";
import Input from "@/components/Input.vue";
import InputDate from "@/components/InputDate.vue";
import ImageInput from "@/components/ImageInput.vue";
import router from "@/router";
import { createFormData, formatDateWithSeparator } from "@/mixins/Helper.vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import Select2 from '@/components/Select2.vue'
import VueNumberFormat from 'vue-number-format'
import {BASE_URL} from "@/services/api";

// Image par défaut d'une promotion sans visuel : la même étiquette neutre que dans la liste
// des promotions du back-office (servie par l'API, jamais teintée à la couleur du client).
const defaultPromotionImage = brandedPlaceholder('promotion')


const store = useStore()
const route = useRoute()

const title = ref("breadcrumbs.promotion.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.store.dashboard',
    path: '/admin/dashboard'
  },
  {
    name: 'breadcrumbs.promotion.list',
    path: '/admin/promotions'
  },
  {
    name: 'breadcrumbs.promotion.detail',
    path: '/admin/promotion/:id/detail'
  }
])

const formData = ref({
  title: '',
  startDate: '',
  endDate: '',
  description: '',
  image: '',
  image_url: '',
  online: null,
  apply: null,
  appliesToAllShops: true,
  shops: [],
  appliesToAllProducts: false,
  autoNotify: true,
  notifyStartTime: '09:00',
  notifyReminderDays: 1,
  notifyReminderTime: '10:00',
  defaultTypeDiscount: null,
  defaultReduction: null,
  defaultTag: null,
  promotions: [
      {
        tag: null,
        type_discount: null,
        reduction: null,
        buy_quantity: 2,
        get_quantity: 1,
        gift_ids: [],
        products: []
      }
  ]
})

const isLoading = ref(false)
const processUpdating = ref(false)
const promotions = ref([])
const currency = ref('')
const currentPromotionIndex = ref(null)
// Arrivée via "Produits stagnants" (voir initFormData()) : la promotion ne
// doit s'appliquer qu'aux produits explicitement choisis là-bas, donc pas de
// case "appliquer à tous les produits" qui permettrait de l'écraser.
const fromStagnantSelection = ref(false)
// Création : la page s'ouvre vide (/promotion/new) et un seul « Enregistrer » crée
// la promotion avec ses produits — rien n'est en base avant.
const isCreate = computed(() => !route.params.id)

const locale = computed(() => i18n.global.locale)
const promotion = computed(() => store.getters['promotion/getCurrentPromotion'])
const getApplies = computed(() => store.getters['promotion/getAppliesEnum'])
const getDiscountTypes = computed(() => store.getters['promotion/getDiscountTypes'])
// catégories parentes sans produit propre : pas de groupe vide dans les listes
const categoriesWithProducts = computed(() => (getProductsByCategories.value || []).filter(category => category.sale_elements?.length))
// « Achetez X, obtenez Y » : seulement sur des produits choisis, pas sur tout le catalogue
const priceDiscountTypes = computed(() => (getDiscountTypes.value || []).filter(type => type.value !== 'buy_x_get_y'))
const getProductsByCategories = computed(() => store.getters['products/getProductSaleElementsByCategories'])
const getCategories = computed(() => store.getters['categories/getCategories'])
const societyShops = computed(() => store.getters['society/getSocietyShops'])
const hasMultipleShops = computed(() => societyShops.value.length > 1)


const categoryModal = ref({
  show: false,
  promotionIndex: null,
  selectedCategories: [],
  products: []
})

const groupedProductsByCategory = computed(() => {
  if (!categoryModal.value.products.length) return []

  const groups = {}
  categoryModal.value.products.forEach(p => {
    const key = p.categoryName || 'Autres'
    if (!groups[key]) groups[key] = []
    groups[key].push(p)
  })

  return Object.keys(groups).map(name => ({
    categoryName: name,
    products: groups[name]
  }))
})

function removeProductFromModal(productId) {
  categoryModal.value.products = categoryModal.value.products.filter(p => p.id !== productId)
}

watch(() => promotion.value, async () => {
  // en création, le store peut encore contenir la dernière promotion ouverte
  if (!isCreate.value) await initFormData()
})

watch(() => categoryModal.value.selectedCategories, (categories) => {
  categoryModal.value.products = []

  if (!categories || !categories.length) return

  categories.forEach(catId => {
    const group = (getProductsByCategories.value || []).find(
      cat => cat.category_id == catId
    )
    if (!group) return

    group.sale_elements.forEach(p => {
      if (!categoryModal.value.products.some(existing => existing.id === p.id)) {
        categoryModal.value.products.push({
          id: p.id,
          name: p.name,
          categoryName: group.category_name   // stocker directement le nom
        })
      }
    })
  })
}, { deep: true })

function initCreateForm () {
  formData.value.online = true
  const today = new Date()
  formData.value.startDate = formatDateWithSeparator(`${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`)
  const pendingProducts = store.getters['promotion/getPendingProducts']
  if (pendingProducts.length) {
    formData.value.promotions[0].products = pendingProducts.map(p => p.id)
    fromStagnantSelection.value = true
    store.commit('promotion/SET_PENDING_PRODUCTS', [])
  }
}

async function initFormData () {
  formData.value.title = promotion.value.title
  formData.value.startDate = formatDateWithSeparator(promotion.value.startDate)
  formData.value.endDate = formatDateWithSeparator(promotion.value.endDate)
  formData.value.apply = promotion.value.apply
  formData.value.image = promotion.value.image
  formData.value.image_url = promotion.value.image_url
  formData.value.online = promotion.value.online
  formData.value.description = promotion.value.description
  formData.value.appliesToAllProducts = !!promotion.value.applies_to_all_products
  formData.value.autoNotify = promotion.value.auto_notify !== false
  formData.value.notifyStartTime = promotion.value.notify_start_time || '09:00'
  formData.value.notifyReminderDays = promotion.value.notify_reminder_days ?? 1
  formData.value.notifyReminderTime = promotion.value.notify_reminder_time || '10:00'
  formData.value.appliesToAllShops = promotion.value.applies_to_all_shops !== false
  formData.value.shops = (promotion.value.shops || []).map(shop => shop.id)
  formData.value.defaultTypeDiscount = promotion.value.default_type_discount
  formData.value.defaultReduction = promotion.value.default_reduction
  formData.value.defaultTag = promotion.value.default_tag
  formData.value.promotions = promotion.value.products
  formData.value.promotions = []
  if(!promotion.value.products.length){
    formData.value.promotions = [
      {
        tag: null,
        type_discount: null,
        reduction: null,
        buy_quantity: 2,
        get_quantity: 1,
        gift_ids: [],
        products: []
      }
    ]

    // Promotion tout juste créée depuis "Produits stagnants" (voir
    // Shop/StagnantProducts.vue et Promotion/Index.vue) : les produits
    // sélectionnés là-bas attendent dans ce state, à injecter une seule
    // fois puis à vider pour ne pas les réappliquer sur une prochaine
    // promotion éditée.
    const pendingProducts = store.getters['promotion/getPendingProducts']
    if (pendingProducts.length) {
      formData.value.promotions[0].products = pendingProducts.map(p => p.id)
      fromStagnantSelection.value = true
      store.commit('promotion/SET_PENDING_PRODUCTS', [])
    }
  }
  for (let i=0; i < promotion.value.products.length; i++) {
    const productIds = promotion.value.products[i].products.map(product => product.id)
    formData.value.promotions.push({
      tag: promotion.value.products[i].tag,
      type_discount: promotion.value.products[i].type_discount,
      reduction: promotion.value.products[i].reduction,
      buy_quantity: promotion.value.products[i].buy_quantity ?? 2,
      get_quantity: promotion.value.products[i].get_quantity ?? 1,
      gift_ids: promotion.value.products[i].gift_product_sale_element_id ? [promotion.value.products[i].gift_product_sale_element_id] : [],
      products: productIds
    })
  }
}

async function updatePromotion () {
  processUpdating.value = true
  const data = new FormData()

  data.append("title", formData.value.title)
  data.append("startDate", formData.value.startDate)
  data.append("endDate", formData.value.endDate)
  data.append("apply", formData.value.apply)
  data.append("image", formData.value.image)
  data.append("description", formData.value.description)

  formData.value.online ? data.set(`online`, 1) : data.set(`online`, 0)
  formData.value.image instanceof File
      ? data.append(`image`, formData.value.image)
      : data.append(`image`, '')

  data.set('applies_to_all_products', formData.value.appliesToAllProducts ? 1 : 0)
  data.set('auto_notify', formData.value.autoNotify ? 1 : 0)
  data.set('notify_start_time', formData.value.notifyStartTime || '09:00')
  data.set('notify_reminder_days', formData.value.notifyReminderDays ?? 1)
  data.set('notify_reminder_time', formData.value.notifyReminderTime || '10:00')

  if (hasMultipleShops.value) {
    data.set('applies_to_all_shops', formData.value.appliesToAllShops ? 1 : 0)
    if (!formData.value.appliesToAllShops) {
      for (let i = 0; i < formData.value.shops.length; i++) {
        data.append(`shops[${i}]`, formData.value.shops[i])
      }
    }
  }

  if (formData.value.appliesToAllProducts) {
    data.append('default_type_discount', formData.value.defaultTypeDiscount)
    data.append('default_reduction', formData.value.defaultReduction)
    data.append('default_tag', formData.value.defaultTag || '')
  } else {
    for (let i=0; i<formData.value.promotions.length; i++) {
      data.append(`promotions[${i}][tag]`, formData.value.promotions[i].tag)
      data.append(`promotions[${i}][type_discount]`, formData.value.promotions[i].type_discount)
      if (formData.value.promotions[i].type_discount === 'buy_x_get_y') {
        data.append(`promotions[${i}][reduction]`, 0)
        data.append(`promotions[${i}][buy_quantity]`, formData.value.promotions[i].buy_quantity ?? '')
        data.append(`promotions[${i}][get_quantity]`, formData.value.promotions[i].get_quantity ?? '')
        // aucun produit choisi = le même produit est offert
        const giftId = (formData.value.promotions[i].gift_ids || [])[0]
        if (giftId) {
          data.append(`promotions[${i}][gift_product_sale_element_id]`, giftId)
        }
      } else {
        data.append(`promotions[${i}][reduction]`, formData.value.promotions[i].reduction)
      }
      for (let j=0; j<formData.value.promotions[i].products.length; j++) {
        data.append(`promotions[${i}][products][${j}]`, formData.value.promotions[i].products[j])
      }
    }
  }

  const request = isCreate.value
      ? store.dispatch('promotion/createPromotion', data)
      : (data.append('promotion_id', route.params.id),
         data.append('_method', "PATCH"),
         store.dispatch('promotion/updatePromotion', {id: route.params.id, data}))

  await request
      .then(res => {
        processUpdating.value = false
        window.toastr['success'](i18n.global.t(isCreate.value ? 'notification.promotion.create_success' : 'notification.promotion.update_success'))
        router.push({ name: 'promotions' })
      })
      .catch(err => {
        processUpdating.value = false
      })
}

async function loadData() {
  if (!isCreate.value) {
    await store.dispatch('promotion/getPromotion', route.params?.id)
  }
  await store.dispatch('promotion/loadAppliesEnum')
  await store.dispatch('promotion/loadDiscountType')
  await store.dispatch('categories/loadCategories')
  await store.dispatch('products/loadAllProductSaleByCategories')
}

function openCategoryModal(index) {
  categoryModal.value = {
    show: true,
    promotionIndex: index,
    selectedCategories: [],
    products: []
  }

  $('#promotionByCategoryModal').modal('show')
}

function getProductById(productId) {
  for (const category of (getProductsByCategories.value || [])) {
    const found = category.sale_elements?.find(p => p.id === productId)
    if (found) return found
  }
  return null
}

function getGroupedProducts(promotionIndex) {
  const productIds = formData.value.promotions[promotionIndex].products
  if (!productIds.length) return []

  const groups = {}

  // Parcourir les groupes catégorie → chercher les produits qui matchent
  ;(getProductsByCategories.value || []).forEach(cat => {
    cat.sale_elements?.forEach(se => {
      if (productIds.includes(se.id)) {
        const key = cat.category_name
        if (!groups[key]) groups[key] = []
        groups[key].push({ id: se.id, name: se.name })
      }
    })
  })

  // Produits non trouvés dans aucune catégorie
  const foundIds = Object.values(groups).flat().map(p => p.id)
  const missing = productIds.filter(id => !foundIds.includes(id))
  if (missing.length) {
    groups['Autres'] = missing.map(id => ({ id, name: 'Produit inconnu' }))
  }

  return Object.keys(groups).map(name => ({
    categoryName: name,
    products: groups[name]
  }))
}

function removeProduct(promotionIndex, productId) {
  formData.value.promotions[promotionIndex].products =
      formData.value.promotions[promotionIndex].products.filter(id => id !== productId)
}

function confirmCategoryProducts() {
  const index = categoryModal.value.promotionIndex

  const productIds = categoryModal.value.products.map(p => p.id)

  formData.value.promotions[index].products = [
    ...new Set([
      ...formData.value.promotions[index].products,
      ...productIds
    ])
  ]

  $('#promotionByCategoryModal').modal('hide')
}

function initSelect2Categories() {
  const selector = '#category_select_0'

  // Détruire Select2 si déjà initialisé
  if ($(selector).hasClass('select2-hidden-accessible')) {
    $(selector).select2('destroy')
  }

  // Initialisation Select2
  $(selector).select2({
    dropdownParent: $('#promotionByCategoryModal')
  })

  // Nettoyer les anciens events
  $(selector).off('change')

  // Listener change
  $(selector).on('change', (e) => {
    const selected = Array.from(e.target.selectedOptions || [])
        .map(opt => opt.value)
        .filter(v => v !== '' && v !== undefined)

    // ✅ Affectation CORRECTE
    categoryModal.value.selectedCategories = selected
  })
}

const modalSelectedProducts = ref([])

const openProductModal = (index) => {
  currentPromotionIndex.value = index
  // Charger la sélection actuelle
  modalSelectedProducts.value = [...formData.value.promotions[index].products]
  $('#productModal').modal('show')
}

const confirmProducts = () => {
  formData.value.promotions[currentPromotionIndex.value].products = [
    ...new Set([
      ...formData.value.promotions[currentPromotionIndex.value].products,
      ...modalSelectedProducts.value
    ])
  ]
  $('#productModal').modal('hide')
}

// Bascule « Appliquer à tous les produits » : les champs de l'autre mode sont vidés,
// pour ne jamais enregistrer un mélange des deux (groupes de produits / remise globale).
function onAppliesToAllProductsChange() {
  if (formData.value.appliesToAllProducts) {
    formData.value.promotions = [{
      tag: null,
      type_discount: null,
      reduction: null,
      buy_quantity: 2,
      get_quantity: 1,
      gift_ids: [],
      products: []
    }]
  } else {
    formData.value.defaultTypeDiscount = null
    formData.value.defaultReduction = null
    formData.value.defaultTag = null
  }
}

function addRow() {
  formData.value?.promotions.push({
    tag: '',
    type_discount: getDiscountTypes.value[0].value,
    reduction: 0.0,
    buy_quantity: 2,
    get_quantity: 1,
    gift_ids: [],
    products: []
  })

}

function dropRow(key) {
  if (formData.value?.promotions.length >= 1) {
    formData.value?.promotions.splice(key, 1)
  }
}

onMounted(() => {
  isLoading.value = true
  Promise.all([
      loadData()

  ])
      .then(res => {
        if (isCreate.value) initCreateForm()
        isLoading.value = false
      })
      .catch(err =>  isLoading.value = false)
  store.dispatch('shop/getCurrency').then(response => {
    currency.value = response?.data.currency_symbol ? response?.data.currency_symbol : response?.data.symbol_native
  })
  store.dispatch('society/fetchSociety')
  initSelect2Categories()

})

function labelType(type) {
  switch (type) {
    case 'start':
      return 'Début de la promotion'
    case 'reminder':
      return 'Rappel de fin'
    case 'manual':
      return 'Manuelle'
    case 'expired':
      return 'Désactivée (date échue)'
    default:
      return type
  }
}

function formatTime(datetime) {
  return new Date(datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

function formatDate(datetime) {
  return new Date(datetime).toLocaleDateString()
}

// Envoi manuel : fenêtre avec type, titre et message préremplis (modifiables)
const notifyForm = ref({ type: 'manual', title: '', message: '' })
const notifySending = ref(false)

function notifyDefaults(type) {
  const promoTitle = formData.value.title || promotion.value?.title || ''
  return {
    start: { title: 'Promotion en ligne !', message: `🎉 La promo « ${promoTitle} » est activée.` },
    reminder: { title: 'Fin de promo bientôt !', message: `⏳ La promo « ${promoTitle} » se termine bientôt.` },
    manual: { title: promoTitle, message: `ℹ️ La promo « ${promoTitle} » est dispo.` },
  }[type] || { title: promoTitle, message: '' }
}

watch(() => notifyForm.value.type, (type) => {
  const texts = notifyDefaults(type)
  notifyForm.value.title = texts.title
  notifyForm.value.message = texts.message
})

function sendNotifyPromotion() {
  notifyForm.value = { type: 'manual', ...notifyDefaults('manual') }
  $('#notifyPromotionModal').modal('show')
}

async function submitNotifyPromotion() {
  notifySending.value = true
  try {
    const response = await store.dispatch('promotion/sendPromotionNotify', {
      id: promotion.value.id,
      type: notifyForm.value.type,
      title: (notifyForm.value.title || '').trim(),
      message: (notifyForm.value.message || '').trim(),
    })
    $('#notifyPromotionModal').modal('hide')
    window.toastr['success'](response?.data?.message || i18n.global.t('promotion.notify_sent'))
  } catch (error) {
    window.toastr['error'](error?.response?.data?.message || i18n.global.t('promotion.notify_error'))
  } finally {
    notifySending.value = false
  }
}
</script>


<style scoped>
.product-scroll-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  padding: 4px 0;
}

.product-scroll-list::-webkit-scrollbar {
  width: 5px;
}

.product-scroll-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

.product-scroll-list::-webkit-scrollbar-thumb {
  background: #b5b5c3;
  border-radius: 8px;
}

.product-scroll-list::-webkit-scrollbar-thumb:hover {
  background: #7e8299;
}

.category-group:not(:last-child) {
  border-bottom: 1px solid #e4e6ef;
}

.category-group-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f9f9f9;
  font-size: 0.8rem;
  font-weight: 600;
  color: #3f4254;
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>